"use strict";

import vehicleHeatmapStore from "./../store/vehicleHeatmaps";
import displayedDetailsStore from "./../store/displayedDetails";
import openedDetailsStore from "./../store/openedDetails";

export default {
	getVisibilityOfHeatmap,
	getHeatmapShapeOpacity
};

export {getVisibilityOfHeatmap as getVisibilityOfHeatmap}
export {getHeatmapShapeOpacity as getHeatmapShapeOpacity}

function getVisibilityOfHeatmap(vehicleId) {
	const descriptor = openedDetailsStore.get(vehicleId);
	if (!descriptor)
		return false;
	
	if( displayedDetailsStore.get() &&
		displayedDetailsStore.get().id == vehicleId &&
		descriptor.activePage == "heatmap"
	){
		return true;
	}
	
	return false;
}

function getHeatmapShapeOpacity(vehicleId){
	const vehicleHeatmapDescriptors = vehicleHeatmapStore.get(vehicleId);
	if(!vehicleHeatmapDescriptors){
		return null;
	}
	
	const numOfSections = vehicleHeatmapDescriptors.sections.length;
	
	const A = 0.08528092937;
	const n = numOfSections || 0;
	if(n <= 1){
		return 1;
	}
	else if(n >= 28){
		return 0.1
	}
	else{
		return Math.exp(A*(1-n));
	}
}


// WEBPACK FOOTER //
// ./src/utils/vehicleHeatmap.js